<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>Service Record{{' - ' + this.serviceData?.refNo}}</h2>
</div>

<section>
  <nz-card>

   <div [ngClass]="!loading ? 'block' : 'hidden'">
     <div>
       <h5 class="text-primary my-3">Service Information</h5>
       <div class="grid xl:grid-cols-2 gap-4">

         <div class="flex flex-row">
           <div class="w-1 bg-primary mr-4"></div>
           <div class="w-full">
             <div class="grid sm:grid-cols-2 mb-1.5">
               <p>Service Type :</p>
               <p class="font-medium">{{serviceTypeLabelPreview(serviceData?.serviceType)}}</p>
             </div>
             <div *ngIf="serviceData?.serviceType === 'NORMALSERVICE'">
               <div class="grid sm:grid-cols-2 mb-1.5">
                 <p>Service will be done by :</p>
                 <p class="font-medium">{{labelValOnServiceType(serviceData?.fleet.vehicleInventory?.serviceResponsible)}}</p>
               </div>
               <div class="grid sm:grid-cols-2 mb-1.5">
                 <p>Service Oil change will be done by :</p>
                 <p class="font-medium">{{labelValOnServiceType(serviceData?.fleet.vehicleInventory?.serviceOilChangeResponsible)}}</p>
               </div>
               <div class="grid sm:grid-cols-2 mb-1.5">
                 <p>Last Service Date :</p>
                 <p class="font-medium">{{serviceData?.fleet.vehicleInventory?.latestServiceDate ? (serviceData?.fleet.vehicleInventory?.latestServiceDate | date: "dd-MM-y") : "-"}}</p>
               </div>
               <div class="grid sm:grid-cols-2 mb-1.5">
                 <p>Last Service Mileage :</p>
                 <p class="font-medium">{{serviceData?.fleet.vehicleInventory?.latestServiceMileage ? serviceData?.fleet.vehicleInventory?.latestServiceMileage + 'km' : '-'}}</p>
               </div>
               <div class="grid sm:grid-cols-2 mb-1.5">
                 <p>Next Service Mileage :</p>
                 <p class="font-medium">{{serviceData?.fleet.vehicleInventory?.nextServiceMileage ? serviceData?.fleet.vehicleInventory?.nextServiceMileage + 'km' : '-'}}</p>
               </div>
             </div>
             <div *ngIf="serviceData?.serviceType === 'TRANSMISSION'">
               <div class="grid sm:grid-cols-2">
                 <p>Transmission oil Will be Done by :</p>
                 <p class="font-medium">{{labelValOnServiceType(serviceData?.fleet.vehicleInventory?.oilChangeResponsible)}}</p>
               </div>
               <div class="grid sm:grid-cols-2">
                 <p>Last Transmission oil Date :</p>
                 <p class="font-medium">{{serviceData?.fleet.vehicleInventory?.latestOilChangeDate ? (serviceData?.fleet.vehicleInventory?.latestOilChangeDate | date: "dd-MM-y") : "-"}}</p>
               </div>
               <div class="grid sm:grid-cols-2">
                 <p>Last Transmission oil Mileage :</p>
                 <p class="font-medium">{{serviceData?.fleet.vehicleInventory?.latestOilChangedMileage ? serviceData?.fleet.vehicleInventory?.latestOilChangedMileage + 'km' : '-'}}</p>
               </div>
               <div class="grid sm:grid-cols-2">
                 <p>Next Transmission oil Mileage :</p>
                 <p class="font-medium">{{serviceData?.fleet.vehicleInventory?.nextOilChangedMileage ? serviceData?.fleet.vehicleInventory?.nextOilChangedMileage + 'km' : '-'}}</p>
               </div>
             </div>
             <div *ngIf="serviceData?.remark" class="grid sm:grid-cols-2">
               <p>Notes :</p>
               <p class="font-medium">{{serviceData?.remark}}</p>
             </div>
             <!--            <div>-->
             <!--              <div>-->
             <!--                <p>Notes</p>-->
             <!--                <td>{{serviceData.remark}}</td>-->
             <!--              </div>-->
             <!--            </div>-->

           </div>
         </div>


         <div class="flex flex-row">
           <div class="w-1 bg-primary mr-4"></div>
           <div>
             <p>Attachments</p>
             <div class="flex flex-col mt-2">
               <a *ngFor="let file of serviceData?.attachments" href="{{file.url}}" [nz-tooltip]="file.name"
                  target="_blank"><span nz-icon nzType="file"
                                        nzTheme="outline"></span><span
                 class="ml-2">{{file.name}}</span></a>
             </div>
           </div>
         </div>

       </div>
     </div>


     <div class="mt-10">
       <h5 class="text-primary my-3">Actions List</h5>
       <nz-alert class="sm:hidden mb-2" nzType="info" nzMessage="Scroll horizontally to see more..."></nz-alert>
       <div class="grid xl:grid-cols-3">

         <div class="xl:col-span-2 whitespace-nowrap overflow-x-auto">
           <form nz-form [formGroup]="actionListForm" class="mb-5">
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Oil Change Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isOilChange">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Oil Filter Change Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isOilFilterChange">Done</span>
               </div>
             </tr>
             <tr *ngIf="serviceData?.serviceType === 'TRANSMISSION'" class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Transmission Oil Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isTransIolCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Coolant Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isCoolantCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Break Oil Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isBreakOilCheck">Done</span>
                 <span nz-checkbox nzDisabled formControlName="isNextBreakOilCheck">Change/check next service</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Air Filter Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isAirFilterCheck">Done</span>
                 <span nz-checkbox nzDisabled formControlName="isNextAirFilterCheck">Change/check next service</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Battery Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isBatteryCheck">Done</span>
                 <span nz-checkbox nzDisabled formControlName="isNextBatteryCheck">Change/check next service</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Cabin Filter Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isCabinFilterCheck">Done</span>
               </div>
             </tr>

             <tr class="my-2"></tr>

             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Break Pads Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isBreakPadCheck">Done</span>
                 <span nz-checkbox nzDisabled formControlName="isNextBreakPadCheck">Change/check next service</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Tyre Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isTypeCheck">Done</span>
                 <span nz-checkbox nzDisabled formControlName="isNextTypeCheck">Change/check next service</span>
               </div>
             </tr>

             <tr class="flex my-2"></tr>

             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Under Carriage Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isUnderCarriageCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Boot Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isBootCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Oil Leak Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isOilLeakCheck">Done</span>
               </div>
             </tr>

             <tr class="flex my-2"></tr>

             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Wiper Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isWiperCheck">Done</span>
                 <span nz-checkbox nzDisabled formControlName="isNextWiperCheck">Change/check next service</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Horn Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isHornCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Interior Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isInteriorCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">A/C Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isACCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Bluetooth Connection Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isBluetoothCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Interior Light Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isInteriorLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Power Mirror Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isPowerMirrorCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Power Shutter Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isPowerShutterCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Hand Break Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isHandBreakCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Spare Wheel Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isSpareWheelCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Toolkit Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isSpareWheelCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Glue Bottle Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isGlueBottleCheck">Done</span>
               </div>
             </tr>

             <tr class="flex my-2"></tr>

             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Front Head Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isFrontHeadLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Front Signal Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isFrontSignalLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Fog Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isFogLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Winker Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isWinkerLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Rear Signal Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isRearSignalLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Break Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isBreakLightCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Revers Lights Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isReversLightCheck">Done</span>
               </div>
             </tr>

             <tr class="flex my-2"></tr>

             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Carpet Wash Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isCarpetWashCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Full Body Wash Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isFullBodyWashCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Under Carriage Wash Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isUnderCarriageWashCheck">Done</span>
               </div>
             </tr>
             <tr class="grid grid-cols-12">
               <td class="col-span-11 min-[425px]:col-span-9 sm:col-span-6">Engine De-greasing Check</td>
               <div>
                 <span nz-checkbox nzDisabled formControlName="isEngineGreasingCheck">Done</span>
               </div>
             </tr>

           </form>
         </div>

       </div>
     </div>
   </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>
  </nz-card>
</section>
